import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { emojify } from 'react-emojione';

import TextArea from 'components/TextArea';
import Button from 'components/Button';
import Link from 'components/Link';
import './style.scss';
import Emojis from '../Emojis';

export class TextEditor extends Component {

  constructor(props) {
    super(props);

    this.pendingCaretPosition = -1;

    this.handleTextUpdate = this.handleTextUpdate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleEmojisToggle = this.handleEmojisToggle.bind(this);
    this.handleEmojiSelected = this.handleEmojiSelected.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    this.focusIfNecessary();
  }

  componentDidUpdate() {
    this.focusIfNecessary();

    if(this.pendingCaretPosition >= 0) {
      this.refs.textarea.setCaretPosition(this.pendingCaretPosition);
      this.pendingCaretPosition = -1;
    }
  }

  componentWillUnmount() {
    if(this.props.onWillUnmount) {
      this.props.onWillUnmount();
    }
  }

  focusIfNecessary() {
    if(this.props.shouldFocusOnMountAndUpdate) {
      this.focus();
    }
  }

  handleTextUpdate(event) {
    this.props.onTextUpdate(event.target.value);
  }

  handleSubmit(event) {
    event.preventDefault();

    if(!this.props.isSubmitDisabled) {
      this.props.onSubmit(this.props.text);
    }
  }

  handleOnFocus() {
    if(this.props.onFocus) {
      this.props.onFocus();
    }
  }

  handleEmojisToggle(event) {
    event.preventDefault();
    this.props.onEmojisToggled(this.props.showsEmojis);
  }

  handleEmojiSelected(emojiShortName) {
    this.pendingCaretPosition = this.getTextSelectionStart();
    this.props.onEmojiSelected(this.props.text, emojiShortName, this.pendingCaretPosition);
    this.focus();
  }

  handleCancel(event) {
    event.preventDefault();
    this.props.onCancel && this.props.onCancel();
  }

  focus() {
    this.refs.textarea.focus();
  }

  getTextSelectionStart() {
    return this.refs.textarea.getSelectionStart();
  }

  render() {
    const { allowsCanceling = false, hasMediumHeight = false, contentTitle = __('members.textEditor.contentLabel')} = this.props;

    return (
      <section className="TextEditor">
        <h1>{this.props.title}</h1>
        <form>
          <label>{contentTitle}</label>

          <TextArea placeholder={this.props.placeholder}
                            ref="textarea"
                     isExpanded={this.props.isExpanded}
                hasMediumHeight={hasMediumHeight}
                    isAutosized={this.props.isAutosized}
                          value={this.props.text}
                        onFocus={this.handleOnFocus}
                       onChange={this.handleTextUpdate} />

          <Emojis isVisible={this.props.showsEmojis} onEmojiSelected={this.handleEmojiSelected} isUnderTextArea />

          {(() => {
            if(this.props.isExpanded) {
              return (
                <div>
                  <div className="submit">
                    <Button
                      isXSmall
                      isYellow
                      onClick={this.handleSubmit}
                      isDisabled={this.props.isSubmitDisabled}>
                      {this.props.isSubmitting ? __('members.textEditor.submitting') : __('members.textEditor.submit')}
                    </Button>
                    {allowsCanceling && <Link onClick={this.handleCancel}>{__('members.textEditor.cancel')}</Link>}
                  </div>

                  <div className="emoji-trigger">
                    <Link onClick={this.handleEmojisToggle}>{emojify(':)', {output: 'unicode'})}</Link>
                  </div>

                  <div className={classnames('character-count', {'is-exceeded': this.props.isCharsLimitExceeded})}>
                    <span className="">{this.props.text.length}</span>/{this.props.maxChars}
                  </div>
                </div>
              );
            }
          })()}
        </form>
      </section>
    );
  }
}

TextEditor.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
  contentTitle: PropTypes.string,
  placeholder: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isSubmitDisabled: PropTypes.bool,
  isCharsLimitExceeded: PropTypes.bool,
  maxChars: PropTypes.number,
  onTextUpdate: PropTypes.func,
  onSubmit: PropTypes.func,
  isExpanded: PropTypes.bool,
  shouldFocusOnMountAndUpdate: PropTypes.bool,
  allowsCanceling: PropTypes.bool,
  isAutosized: PropTypes.bool,
  hasMediumHeight: PropTypes.bool,
  onFocus: PropTypes.func,
  onWillUnmount: PropTypes.func,
  showsEmojis: PropTypes.bool,
  onEmojisToggled: PropTypes.func,
  onEmojiSelected: PropTypes.func,
  onCancel: PropTypes.func
};

export default TextEditor;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/TextEditor/index.js
 **/